import styled from "styled-components";
import { TextButton, WrapperContainer } from "../../../../../components";

export const FiltersWrapper = styled(WrapperContainer)`
  ${(props) => !props.visible && `display: none;`}

  ${TextButton} {
    padding: 9px 24px;
  }
`;
